import React from 'react';
import Header from './Header';
import Footer from './Footer';
import BannerSection from './BannerSection';
import HTMLFlipBook from 'react-pageflip';
import Company_Profile from './assets/Company_Profile.pdf';
import { AiOutlineDownload } from 'react-icons/ai';

const CompanyProfile = () => {
  const pages = [
    {
      src: `${process.env.PUBLIC_URL}/images/pdfImages/Memories_Maker-3_page-0001.jpg`,
    },
    {
      src: `${process.env.PUBLIC_URL}/images/pdfImages/Memories_Maker-3_page-0002.jpg`,
    },
    {
      src: `${process.env.PUBLIC_URL}/images/pdfImages/Memories_Maker-3_page-0003.jpg`,
    },
    {
      src: `${process.env.PUBLIC_URL}/images/pdfImages/Memories_Maker-3_page-0004.jpg`,
    },
    {
      src: `${process.env.PUBLIC_URL}/images/pdfImages/Memories_Maker-3_page-0005.jpg`,
    },
    {
      src: `${process.env.PUBLIC_URL}/images/pdfImages/Memories_Maker-3_page-0006.jpg`,
    },
    {
      src: `${process.env.PUBLIC_URL}/images/pdfImages/Memories_Maker-3_page-0007.jpg`,
    },
    {
      src: `${process.env.PUBLIC_URL}/images/pdfImages/Memories_Maker-3_page-0008.jpg`,
    },
    {
      src: `${process.env.PUBLIC_URL}/images/pdfImages/Memories_Maker-3_page-0009.jpg`,
    },
    {
      src: `${process.env.PUBLIC_URL}/images/pdfImages/Memories_Maker-3_page-0010.jpg`,
    },
    {
      src: `${process.env.PUBLIC_URL}/images/pdfImages/Memories_Maker-3_page-0011.jpg`,
    },
    {
      src: `${process.env.PUBLIC_URL}/images/pdfImages/Memories_Maker-3_page-0012.jpg`,
    },
    {
      src: `${process.env.PUBLIC_URL}/images/pdfImages/Memories_Maker-3_page-0013.jpg`,
    },
    {
      src: `${process.env.PUBLIC_URL}/images/pdfImages/Memories_Maker-3_page-0014.jpg`,
    },
    {
      src: `${process.env.PUBLIC_URL}/images/pdfImages/Memories_Maker-3_page-0015.jpg`,
    },
  ];

  const FlipPage = React.forwardRef(({ src, alt }, ref) => (
    <div ref={ref} className="pdfPage">
      <img src={src} style={{ width: '100%', height: '90%' }} alt={alt} />
    </div>
  ));
  return (
    <>
      <Header />
      <BannerSection pageHeader="COMPANY PROFILE" />
      <div className="blogContenT">
        <iframe
          src={`${process.env.PUBLIC_URL}/Memories_Maker_Profile.pdf`}
          name="exam_frame"
        ></iframe>
      </div>

      <div className="flipBook">
        <HTMLFlipBook width={300} height={550} size="stretch">
          {pages && pages.length > 0 ? (
            pages.map((page, index) => (
              <FlipPage key={index} src={page.src} alt={`Page ${index}`} />
            ))
          ) : (
            <p>Loading pages...</p>
          )}
        </HTMLFlipBook>
      </div>
      <div className="cta">
        <p>You can also Download the PDF of our Company Profile here</p>
        <a href={Company_Profile} download className="BTN">
          Download{' '}
          <span>
            <AiOutlineDownload />
          </span>
        </a>
      </div>
      <Footer />
    </>
  );
};

export default CompanyProfile;
